<template>
  <div class="w-100 h-100">
    <div class="container" v-for="(i, ii) in H" :key="i">
      <table border="1" cellspacing="0">
        <thead>
          <tr>
            <th :colspan="tableList[i].C01.length / 2" style="width: 50%;">
              {{$route.query.stockPosition}}
            </th>
            <th :colspan="tableList[i].C01.length / 2">
              {{i}}
            </th>
          </tr>
        </thead>
        <tbody ref="table">
          <tr v-for="(c, ic) in C" :key="i + c">
            <template v-for="(l, index) in tableList[i][c]">
              <td v-if="Array.isArray(l)" style="position: relative; overflow: hidden;" @mouseenter="pauseAni(ii, ic, index)" @mouseleave="restartAni(ii, ic, index)">
                <div 
                  style="position: absolute; top: 0; left: 0; right: 0; z-index: 100;" class="animation"
                  :data-position="i + ',' + c + ',' + index"
                >
                  <div
                    :style="{height: rowHeight + 'px', overflow: 'hidden', borderBottom: '1px solid #333'}"
                    v-for="(item, index) in l" 
                    :key="item.code + index" 
                    :class="{ green: item.productCode && +item.qty >= +item.safeStock, red: +item.qty <= +item.warnStock, yellow: +item.qty > +item.warnStock && +item.qty < +item.safeStock, blue: !item.productCode, gray: item.code.substring(item.code.length - 1, item.code.length) === 'T' }"
                  >
                    <div class="content">
                      {{item.productCode || '8.02.015.0096'}}
                    </div>
                    <div :title="`${(item.productModel && item.productModel.length > 8) ? item.productModel : ''}` "style="font-size: 12px; white-space: nowrap;"  :style="{textAlign: l.productModel && l.productModel.length > 14 ? 'left' : 'center', width: rowWidth + 'px', overflow: 'hidden'}">
                      {{item.productModel}}
                    </div>
                    <div class="content words">
                      <strong>{{item.productCode ? item.qty : 1}}</strong>
                    </div>
                  </div>
                  <div
                    :style="{height: rowHeight + 'px', borderBottom: '1px solid #333'}"
                    v-for="(item, index) in l"
                    :key="-index" 
                    :class="{ green: item.productCode && +item.qty >= +item.safeStock, red: +item.qty <= +item.warnStock, yellow: +item.qty > +item.warnStock && +item.qty < +item.safeStock, blue: !item.productCode, gray: item.code.substring(item.code.length - 1, item.code.length) === 'T' }"
                  >
                    <div class="content">
                      {{item.productCode || '8.02.015.0096'}}
                    </div>
                    <div :title="`${(item.productModel && item.productModel.length > 8) ? item.productModel : ''}` "style="font-size: 12px; white-space: nowrap;"  :style="{textAlign: l.productModel && l.productModel.length > 14 ? 'left' : 'center', width: rowWidth + 'px', overflow: 'hidden'}">
                      {{item.productModel}}
                    </div>
                    <div class="content words">
                      <strong>{{item.productCode ? item.qty : 1}}</strong>
                    </div>
                  </div>
                </div>
              </td>
              <td v-else :key="index" :class="{green: l.productCode && +l.qty >= +l.safeStock, red: +l.qty <= +l.warnStock, yellow: +l.qty > +l.warnStock && +l.qty < +l.safeStock, blue: !l.productCode, gray: l.code.substring(l.code.length - 1, l.code.length) === 'T' }">
                <div class="content">
                  {{l.productCode || '8.02.015.0096'}}
                </div>
                <div :title="`${(l.productModel && l.productModel.length > 8) ? l.productModel : ''}`" style="font-size: 12px; white-space: nowrap;" :style="{textAlign: l.productModel && l.productModel.length > 14 ? 'left' : 'center', width: rowWidth + 'px', overflow: 'hidden'}">
                  {{l.productModel}}
                </div>
                <!-- <div>
                  {{l.productModel}}
                </div> -->
                <div class="content words">
                  <strong>{{l.productCode ? l.qty : 1}}</strong>
                </div>
              </td>
            </template>
          </tr>
          <tr ref="lastTr">
            <template v-for="(ll, index) in tableList[i].C01">
              <td v-if="Array.isArray(ll)" ref="td">
                {{ll[0].code.substring(15, 18)}}
              </td>
              <td v-else>{{ll.code.substring(15, 18)}}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mseApi from "@/api/mes";

export default {
  data() {
    return {
      H: [],
      C: [],
      tableList: {},
      rowHeight: 0,
      colNum: 0,
      rowWidth: 0
    };
  },
  created() {
    this.getTableList();
  },
  mounted() {
    this.timer = setInterval(this.getTableList, 10 * 60 * 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    async getTableList() {
      let H = []
      let C = []
      let tableList = {}
      try {
        const { data } = await mseApi.getList(this.$route.query.stockPosition)
        data.forEach((d) => {
          if(!tableList[d.code.substring(11, 14)]) {
            H.push(d.code.substring(11, 14))
            tableList[d.code.substring(11, 14)] = {}
          }
          if(!tableList[d.code.substring(11, 14)][d.code.substring(19, 22)]) {
            tableList[d.code.substring(11, 14)][d.code.substring(19, 22)] = []
          }
          const a = tableList[d.code.substring(11, 14)][d.code.substring(19, 22)]
          const index = a.findIndex(item => {
            if(Array.isArray(item)) {
              return item[0].code === d.code
            }
            return item.code === d.code
          })
          if(index > -1) {
            if(Array.isArray(a[index])) {
              a[index].push(d)
            } else {
              a[index] = [a[index], d]
            }
          } else {
            tableList[d.code.substring(11, 14)][d.code.substring(19, 22)].push(d);
          }
        })
        for (let k in tableList[H[0]]) {
          C.unshift(k);
        }
        this.$nextTick().then(() => {
          this.rowHeight = Math.floor((this.$refs.table[0].clientHeight - this.$refs.lastTr[0].clientHeight) / this.C.length + 8)
          const container = document.querySelector('.container')
          this.rowWidth = Math.floor((container.clientWidth - 40) / this.tableList[this.H[0]].C01.length)
          const animations = document.querySelectorAll('.animation')
          animations.forEach(dom => {
            const positionInfo = dom.getAttribute('data-position').split(',')
            const second = this.tableList[positionInfo[0]][positionInfo[1]][positionInfo[2]].length * 2 + 's'
            dom.style.animationDuration = second
          })
        })
      } catch {
        H = this.H
        C = this.C
        tableList = this.tableList
      }
      this.H = H
      this.C = C
      this.tableList = tableList
    },
    pauseAni(i, c, index) {
      this.$refs.table[i].childNodes[c].childNodes[index].childNodes[0].style.animationPlayState = 'paused'
    },
    restartAni(i, c, index) {
      this.$refs.table[i].childNodes[c].childNodes[index].childNodes[0].style.animationPlayState = 'running'
    }
  },
};
</script>

<style scoped>
body {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.container {
  width: 100%;
  height: 50%;
  padding: 5px 10px 10px 10px;
}
.container:first-child {
  padding-bottom: 5px;
}
.container:nth-child(2) {
  padding-top: 5px;
}
.container table {
  width: 100%;
  height: 100%;
  /* background-color: skyblue; */
  text-align: center;
  border: 1px solid #000;
}
.container table thead {
  height: 60px;
  font-size: 20px;
}
.container table tbody td {
  padding: 0;
}
.container table tbody .content {
  height: 33%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}
.container table tbody .words {
  font-size: 14px;
}
/* .container table tbody .splitLine{
  border-right: 2px solid #000;
} */
.container table tbody .green {
  background-color: #3dc741;
}
.container table tbody .yellow {
  background-color: #f2e205;
}
.container table tbody .red {
  background-color: #ff413a;
}
.container table tbody .blue {
  color: transparent;
  background-color: #1cacf4;
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
.container table tbody .gray {
  background-color: #cccccb;
}
.container table tbody .animation {
  animation: scroll 4s linear infinite;
}
@keyframes scroll {
  0% {}
  100% {
    transform: translateY(-50%);
  }
}
</style>
